module.exports = __webpack_public_path__ + "assets/img/zhengshimiduyi.957921aa.jpg";